import './scss/style.scss';

import smoothScroll from '../../src/js/components/smooth-scroll';
import lazyLoadImages from '../../src/js/components/lazy-load-images';
import ELSASlider from '../premium-new-user/js/slider';
import packageSlider from '../premium/js/package-slider';
import premiumScripts from '../premium/js/scripts';

$(function () {
  lazyLoadImages();
  ELSASlider();
  smoothScroll();
  packageSlider();
  premiumScripts();
});

$(window).on('scroll', function () {
  lazyLoadImages();
});
